import moment from 'moment'
import { Availability } from '@/shared/models'

export const INIT_AVAIL = new Availability({
  startTime: moment().add(5, 'days').toDate(),
  endTime: moment().add(10, 'days').toDate(),
  localisation: { longitude: '', latitude: '', address: '' }
})
